import { Button, Divider, Group, Stack, Table, Title } from "@mantine/core";
import { safeApiCall } from "api/common.service";
import { getDebtorBalanceSummary } from "api/report.service";
import { navigateTo } from "common/navigation";
import { formatNZD } from "common/utils";
import React, { useEffect, useRef, useState } from "react";
import { RptDebtorBalanceSummary } from "types/model.types";

const AdminDebtorBalanceSummary: React.FC = () => {
  const [data, setData] = useState<RptDebtorBalanceSummary | null>();
  const [loading, setLoading] = useState(false);
  const apiFetchRef = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      if (apiFetchRef.current) return;
      apiFetchRef.current = true;
      setLoading(true);

      const result = await safeApiCall(getDebtorBalanceSummary());

      setData(result?.data[0] ?? null);
    };

    setLoading(false);
    apiFetchRef.current = false;

    fetchData();
  }, []);

  if (!data) {
    return <Title order={4}>No data available</Title>;
  }

  return (
    <Stack>
      <Group justify="space-between" align="end" gap="sm">
        <Title order={2}>Customer Orders Report</Title>
        <Button
          onClick={() => {
            navigateTo("/print/debtor-balance");
          }}
          variant="gradient"
        >
          Print
        </Button>
      </Group>
      <div id="preview-content">
        <Table striped highlightOnHover withTableBorder>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td className="em">Opening</Table.Td>
              <Table.Td className="em full">{formatNZD(data.opening)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td colSpan={2}>
                <Divider className="divider" />
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">Current</Table.Td>
              <Table.Td>{formatNZD(data.currentMonth)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">30 Days</Table.Td>
              <Table.Td>{formatNZD(data.month1)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">60 Days</Table.Td>
              <Table.Td>{formatNZD(data.month2)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">90 Days</Table.Td>
              <Table.Td>{formatNZD(data.month3)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td colSpan={2}>
                <Divider className="divider" />
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">Balance</Table.Td>
              <Table.Td className="em">{formatNZD(data.balance)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td colSpan={2}>
                <Divider className="divider" />
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">Difference</Table.Td>
              <Table.Td className="em">{formatNZD(data.imBalance)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td colSpan={2}>
                <Divider className="divider" />
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">Sales MTD</Table.Td>
              <Table.Td>{formatNZD(data.salesMtd)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">Cash MTD</Table.Td>
              <Table.Td>{formatNZD(data.cashMtd)}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Td className="em">GST MTD</Table.Td>
              <Table.Td>{formatNZD(data.gstMtd)}</Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </div>
    </Stack>
  );
};

export default AdminDebtorBalanceSummary;
